import { FadeIn } from "./FadeIn";
import { MapPin, ArrowUpRight } from "lucide-react";
import { waLinkFor } from "../constants/contact";
import { NEIGHBORHOODS as PAGES } from "../data/neighborhoods";

const NEIGHBORHOODS = [
  "Adnan Kahveci Mahallesi",
  "Beykent & Cumhuriyet",
  "Barış Mahallesi",
  "Yakuplu & Ambarlı Liman",
  "Marmara Mahallesi",
  "Gürpınar Sahil & İçi",
  "Dereağzı Mahallesi",
  "Kavaklı Mahallesi",
  "Büyükşehir Mahallesi",
  "Sahil Mahallesi",
];

export const ServiceArea = () => (
  <section id="bolgeler" data-testid="area-section" className="relative py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <FadeIn className="text-center">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400 mb-4">
          Hizmet Bölgesi
        </p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-50 leading-tight">
          Beylikdüzü'nün her mahallesindeyiz
        </h2>
        <p className="mt-5 text-base sm:text-lg text-slate-400 max-w-xl mx-auto leading-relaxed">
          İstanbul / Beylikdüzü merkezli çalışıyoruz. Mahallenize dokunun,
          WhatsApp'ta hazır mesajınız açılsın — yazmanıza bile gerek yok.
        </p>
      </FadeIn>

      <FadeIn delay={0.15}>
        <div className="mt-12 flex flex-wrap justify-center gap-3 max-w-4xl mx-auto" data-testid="area-badges">
          {NEIGHBORHOODS.map((n, i) => (
            <a
              key={n}
              href={waLinkFor(n)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`area-badge-${i}`}
              className="group inline-flex items-center gap-2 rounded-full border border-slate-700 bg-[#0F172A] px-4 py-2.5 text-sm text-slate-300 hover:border-green-500/60 hover:text-green-300 hover:bg-green-500/10 transition-colors duration-200"
            >
              <MapPin className="w-3.5 h-3.5 text-amber-400 group-hover:text-green-400 transition-colors duration-200" strokeWidth={2.5} />
              {n}
              <ArrowUpRight className="w-3.5 h-3.5 opacity-0 -ml-1 group-hover:opacity-100 group-hover:ml-0 transition-all duration-200" strokeWidth={2.5} />
            </a>
          ))}
        </div>
      </FadeIn>

      <FadeIn delay={0.2}>
        <div className="mt-12 text-center" data-testid="area-pages">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500 mb-5">
            Mahallenize özel sayfalar
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 max-w-4xl mx-auto">
            {PAGES.map((p) => (
              <a
                key={p.slug}
                href={`/mahalle/${p.slug}`}
                data-testid={`area-page-link-${p.slug}`}
                className="text-sm text-slate-400 underline-offset-4 hover:text-amber-400 hover:underline transition-colors"
              >
                {p.short} Elektrikçi
              </a>
            ))}
          </div>
        </div>
      </FadeIn>
    </div>
  </section>
);
